export default __webpack_public_path__ + "static/media/Arrow.5400b44e.png";